import React from "react";
import { ResultPaginationNumberedProps } from "@usereactify/search";

import Icons from "../Icons/icons";

export type ResultPaginationNumberedPropsType = React.ComponentProps<
  NonNullable<ResultPaginationNumberedProps["render"]>
>;

// Custom hook to handle page changes
const usePageHandler = (handler) => {
  return React.useCallback((page, event) => {
    event.preventDefault();
    handler(page, event);

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 250);
  }, [handler]);
};

export const ResultPaginationNumbered: React.FC<ResultPaginationNumberedPropsType> = (props) => {
  const handlePageChange = usePageHandler(props.handlePageChange);
  const handlePreviousPage = usePageHandler(props.handlePreviousPage);
  const handleNextPage = usePageHandler(props.handleNextPage);

  return (
    <nav className="rs__pagination__nav pagination">
      <div className="row align-center">
        <div className="page-numbers nav-links text-center">
          {props.currentPage > 0 && (
            <a
              className="rs__pagination__prev-link prev"
              rel="prev"
              href={props.buildPagePath(props.currentPage)}
              onClick={(event) => handlePreviousPage(null, event)}
            >
              <Icons name="chevronLeft" />
            </a>
          )}
          {!props.pagesToShow.includes(0) && (
            <a
              className="rs__pagination__pagenumber-link page"
              href={props.buildPagePath(1)}
              onClick={(event) => handlePageChange(0, event)}
              rel={0 === props.currentPage - 1 ? `prev` : undefined}
            >
              {"1"}
            </a>
          )}
          {!props.pagesToShow.includes(1) && <span>...</span>}
          {props.pagesToShow.map((page) =>
            page === props.currentPage ? (
              <span className="rs__pagination__pagenumber-active page" key={page + 1}>
                {page + 1}
              </span>
            ) : (
              <a
                className="rs__pagination__pagenumber-link page"
                key={page + 1}
                href={props.buildPagePath(page + 1)}
                onClick={(event) => handlePageChange(page, event)}
                rel={
                  page === props.currentPage + 1
                    ? `next`
                    : page === props.currentPage - 1
                    ? `prev`
                    : undefined
                }
              >
                {page + 1}
              </a>
            )
          )}
          {!props.pagesToShow.includes(props.totalPages - 2) && <span>...</span>}
          {!props.pagesToShow.includes(props.totalPages - 1) && (
            <a
              className="rs__pagination__pagenumber-link page"
              href={props.buildPagePath(props.totalPages)}
              onClick={(event) => handlePageChange(props.totalPages - 1, event)}
              rel={
                props.totalPages - 1 === props.currentPage + 1
                  ? `next`
                  : props.totalPages - 1 === props.currentPage - 1
                  ? `prev`
                  : undefined
              }
            >
              {props.totalPages}
            </a>
          )}
          {props.currentPage + 1 < props.totalPages && (
            <a
              className="rs__pagination__next-link next"
              rel="next"
              href={props.buildPagePath(props.currentPage + 2)}
              onClick={(event) => handleNextPage(null, event)}
            >
              <Icons name="chevronRight" />
            </a>
          )}
        </div>
      </div>
    </nav>
  );
};